module.exports = __webpack_public_path__ + "static/img/shop_cart.b736ff1.1777542044870.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cartimg/shop_cart.png
// module id = BKp6
// module chunks = 74